(function () {
    const PROGRESS_DURATION = 15000;

    function imageIndexFromItem(item, fallbackIndex) {
        const parsed = Number.parseInt(item.dataset.image ?? '', 10);
        return Number.isNaN(parsed) ? fallbackIndex : parsed;
    }

    function setupAccordion(root) {
        const items = Array.from(root.querySelectorAll('.item'));
        const images = Array.from(root.querySelectorAll('.js-dynamic-accordion-image-wrapper'));
        if (!items.length || !images.length) return;

        let autoAdvanceTimer = null;

        function clearTimer() {
            if (autoAdvanceTimer) {
                clearTimeout(autoAdvanceTimer);
                autoAdvanceTimer = null;
            }
        }

        function setActiveImage(targetImageIndex) {
            images.forEach((image, imageIndex) => {
                image.classList.toggle('js-dynamic-acc-image-active', imageIndex === targetImageIndex);
            });
        }

        function setActiveItem(activeIndex) {
            items.forEach((item, itemIndex) => {
                const isActive = itemIndex === activeIndex;
                if (isActive) {
                    item.setAttribute('open', '');
                    item.classList.add('js-dynamic-acc-active');
                } else {
                    item.removeAttribute('open');
                    item.classList.remove('js-dynamic-acc-active');
                }
            });
        }

        function activate(activeIndex) {
            if (activeIndex < 0 || activeIndex >= items.length) return;

            clearTimer();
            setActiveItem(activeIndex);
            setActiveImage(imageIndexFromItem(items[activeIndex], activeIndex));

            autoAdvanceTimer = setTimeout(() => {
                const nextIndex = (activeIndex + 1) % items.length;
                activate(nextIndex);
            }, PROGRESS_DURATION);
        }

        items.forEach((item, itemIndex) => {
            const summary = item.querySelector('summary');
            if (!summary) return;

            summary.addEventListener('click', (event) => {
                event.preventDefault();
                if (item.classList.contains('js-dynamic-acc-active')) return;
                activate(itemIndex);
            });
        });

        const explicitActive = items.findIndex((item) => item.classList.contains('js-dynamic-acc-active'));
        const initiallyOpen = items.findIndex((item) => item.hasAttribute('open'));
        let initialIndex = 0;
        if (explicitActive >= 0) {
            initialIndex = explicitActive;
        } else if (initiallyOpen >= 0) {
            initialIndex = initiallyOpen;
        }
        activate(initialIndex);
    }

    function run() {
        const roots = document.querySelectorAll('.js-dynamic-accordion-container, .pt-010-cv-maker-accordian, .pt-015-cv-maker-accordian');
        roots.forEach(setupAccordion);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }
})();